<template>
  <div class="auth-page">
    <!-- 重設密碼表單 -->
    <section class="auth-section">
      <div class="container">
        <div class="auth-card">
          <!-- Header 部分 -->
          <div class="reset-header">
            <div class="reset-icon-circle">
              <i class="fas fa-key"></i>
            </div>
            <h2 class="auth-title">重設密碼</h2>
            <p class="auth-description">請設定您的新密碼</p>
          </div>

          <!-- 成功重設訊息 -->
          <div v-if="resetSuccess" class="success-message">
            <div class="success-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <h3 class="success-title">重設成功！</h3>
            <p class="success-text">
              密碼已成功重設，您現在可以使用新密碼登入。
            </p>
            <div class="back-button-container">
              <button @click="goToLogin" class="btn-back">
                <i class="fas fa-arrow-left"></i> 前往登入
              </button>
            </div>
          </div>

          <!-- 重設表單 -->
          <form v-else @submit.prevent="handleResetPassword" class="auth-form">
            <!-- 新密碼 -->
            <div class="form-group">
              <label for="password">新密碼</label>
              <div class="input-wrapper">
                <i class="fas fa-lock input-icon"></i>
                <input
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  v-model="form.password"
                  placeholder="請輸入新密碼"
                  @input="updatePasswordStrength"
                  required
                />
                <i
                  :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                  @click="togglePassword"
                  class="toggle-password"
                ></i>
              </div>

              <!-- 密碼強度指示器 -->
              <div v-if="form.password" class="password-strength-container">
                <div class="strength-bar-wrapper">
                  <div
                    class="strength-bar"
                    :class="`strength-${passwordStrength}`"
                  ></div>
                </div>
                <span class="strength-text" :class="`text-${passwordStrength}`">
                  {{ strengthLabels[passwordStrength] }}
                </span>
              </div>

              <span v-if="errors.password" class="error">{{
                errors.password
              }}</span>
            </div>

            <!-- 確認密碼 -->
            <div class="form-group">
              <label for="confirmPassword">確認密碼</label>
              <div class="input-wrapper">
                <i class="fas fa-lock input-icon"></i>
                <input
                  :type="showConfirmPassword ? 'text' : 'password'"
                  id="confirmPassword"
                  v-model="form.confirmPassword"
                  placeholder="請再次輸入新密碼"
                  required
                />
                <i
                  :class="
                    showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'
                  "
                  @click="toggleConfirmPassword"
                  class="toggle-password"
                ></i>
              </div>
              <span v-if="errors.confirmPassword" class="error">{{
                errors.confirmPassword
              }}</span>
            </div>

            <!-- 提交按鈕 -->
            <button type="submit" class="btn-submit" :disabled="isSubmitting">
              <i v-if="isSubmitting" class="fas fa-spinner fa-spin"></i>
              {{ isSubmitting ? "處理中..." : "重設密碼" }}
            </button>

            <!-- 返回連結 -->
            <div class="auth-footer">
              <p class="auth-link">
                想起密碼了？<router-link to="/login" class="link"
                  >返回登入</router-link
                >
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script src="@/assets/js/reset.js" defer></script>
<style scoped src="@/assets/css/reset.css"></style>
